import React, { useCallback } from "react"

import { Color } from "../../../../../constants/V2/color"
import { trackSegmentEvent } from "../../../../../utils/analytics"
import { getTextColorClass } from "../../../../../utils/V2/color"
import Link from "../../../../elements/Link"
import Typography from "../../../../elements/V2/Typography"

type GetStartedItemProps = {
  label: string
  icon: React.ElementType
  link?: string
  onClick?: () => void
}

export const GetStartedModalItem = ({
  label,
  icon: Icon,
  link,
  onClick,
}: GetStartedItemProps) => {
  const hoverClass = `group-hover:${getTextColorClass(Color.White)}`
  const wrapperClass =
    "group flex h-full w-full items-center gap-20 border-t border-light-gray px-[25px] py-6 hover:bg-blue"

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick()
    }

    trackSegmentEvent("get_started_modal_click", {
      anchorText: label,
      path: link,
    })
  }, [label, link, onClick])

  const content = (
    <>
      <Icon className={hoverClass} />
      <Typography
        font="grotesk"
        size="body-lg"
        weight="book"
        text={label}
        color={Color.Black}
        className={hoverClass}
      />
    </>
  )

  if (link) {
    return (
      <Link link={link} onClick={handleClick} className={wrapperClass}>
        {content}
      </Link>
    )
  }

  return (
    <button onClick={handleClick} className={wrapperClass}>
      {content}
    </button>
  )
}
